import { render, staticRenderFns } from "./Nanzhuang.vue?vue&type=template&id=9b5a2674&"
import script from "./Nanzhuang.vue?vue&type=script&lang=js&"
export * from "./Nanzhuang.vue?vue&type=script&lang=js&"
import style0 from "./Nanzhuang.vue?vue&type=style&index=0&id=9b5a2674&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports